/* eslint-env node, browser */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { setPersonalizedPlate } from '../../redux/modules/registration';
import Dropdown from '../../components/Dropdown';
import { PIPE } from '../../modules/constants';
import getPipeValue from '../../modules/getPipeValue';
import precise from '../../modules/precise';
import secondYearFeeTotal from '../../selectors/secondYearFeeTotal.selector';
import svcFees from '../../modules/SVCFees';
import TextInput from '../../components/TextInput';

const PERSONAL_RENEW = 'personal-renew';
const PERSONAL_ORIGINAL = 'personal-original';
const RADIO_ORIGINAL = 'radio-original';
const RADIO_RENEW = 'radio-renew';
const RADIO = 'radio';
const PERSONAL = 'personal';

class PersonalizedPlateFee extends Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
  }

  initialFee(plate) {
    const monthsFromNow = Number(this.props.monthsFromNow);
    const secondYearFee = Number(this.props.secondYearFee);
    const { applySecondYearFee } = this.props;
    // NOTE: John used to set the default to 3.5 in the PDF
    // but doing so in the web app throws off the calculations by 3.5
    // so lets set `radioReg` to zero for now, until we confirm we don't ever
    // need this mysterious and problematic default of 3.5
    // let radioReg = plate === RADIO ? 3.5 : 0;
    let radioReg = 0;

    // Set these always: Personal = 15, Radio = 1.5
    const initial = plate === PERSONAL ? 15.00 : 1.5;

    let pc = 0;
/* Adjusted to fix months 14-15 Personal Plate Calculation fees)
/*    if (monthsFromNow > 0 && monthsFromNow <= 13) {
      pc = 1;
    }
    if (monthsFromNow > 13 && monthsFromNow <= 15) {
      pc += 2;
    } */
    if (monthsFromNow > 0 && monthsFromNow <= 15) {
      pc = 1;
    }
    if (applySecondYearFee && secondYearFee !== 0) {
      pc += 1;
      radioReg = 0;
    }
    return (pc * initial) + radioReg;
  }

  renew() {
    const { selectedVehicleValue } = this.props;
    const monthsFromNow = Number(this.props.monthsFromNow);
    let classCode = 0;
    let total = 0;
    if (selectedVehicleValue) {
      classCode = Number(getPipeValue(selectedVehicleValue, PIPE.CLASS_CODE));
    }

    if (monthsFromNow !== 0) {
      if (classCode === 65 || classCode === 69 || classCode === 80) {
        total += -8;
      }
    }
    return total;
  }

  original(plate) {
    const { BFfee } = this.props;
    const { OLPfee, RZfee, FVfee, ACfee, EMfee, AVfee, DDfee, SVCfee } = svcFees;
    const reservationFee = plate === RADIO ? 0 : 0;
    return reservationFee + OLPfee + RZfee + FVfee + ACfee + EMfee + AVfee + DDfee + SVCfee + BFfee;
  }

  resetField() {
    this.setState({ selectedValue: 'none' }, () => {
      this.setFee(0, '', 'Personalized Plate Fee');
    });
  }

  setFee(fee, selectedValue, selectedValueLabel) {
    this.props.setPersonalizedPlate(precise(fee), selectedValue, selectedValueLabel);
  }

  onChange(event) {
    const { selectedVehicleValue } = this.props;
    const label = this.peronalizedPlateOptions()[event.target.selectedIndex][0];
    const r20 = selectedVehicleValue ? Number(getPipeValue(selectedVehicleValue, 'r20')) : 0;

    const value = event.target.value;
    if (value === 'none') {
      this.setFee(precise(0), 'none', 'Personalized Plate Fee');
      return;
    }

    const isRadioOption = (value === RADIO_RENEW || value === RADIO_ORIGINAL);
    const isPersonOption = (value === PERSONAL_RENEW || value === PERSONAL_ORIGINAL);
    const isForbiddenRadio = r20 === 1 || r20 === 2;
    const isForbiddenPersonal = r20 === 2;

    // Initially check to see if special plates are available
    if (isPersonOption && isForbiddenPersonal) {
      alert('This Vehicle type is not eligible for Personalized Plates');
      this.resetField();
    }

    if (isRadioOption && isForbiddenRadio) {
      alert('This Vehicle type is not eligible for Amateur Radio plates');
      this.resetField();
    }

    if (value === PERSONAL_RENEW && !isForbiddenPersonal) {
      this.setFee(this.initialFee(PERSONAL) + this.renew(), value, label);
    } else if (value === PERSONAL_ORIGINAL && !isForbiddenPersonal) {
      this.setFee(this.initialFee(PERSONAL) + this.original(PERSONAL), value, label);
    } else if (value === RADIO_RENEW && !isForbiddenRadio) {
      this.setFee(this.initialFee(RADIO) + this.renew(), value, label);
    } else if (value === RADIO_ORIGINAL && !isForbiddenRadio) {
      this.setFee(this.initialFee(RADIO) + this.original(RADIO), value, label);
    }
  }

  peronalizedPlateOptions() {
    return [
      ['No Personal Plate', 'none'],
      ['Personalized Plate (Renewal Only)', PERSONAL_RENEW],
      ['Personalized Plate (Original Reservation or reorder different specialty sheeting)', PERSONAL_ORIGINAL],
      ['Amatuer Radio Plate (Renewal Only)', RADIO_RENEW],
      ['Amatuer Radio Plate (Original Reservation)', RADIO_ORIGINAL],
    ];
  }

  render() {
    const { personalizedPlateFee, personalizedPlateFeeSelectedValue, personalizedPlateFeeSelectedValueLabel } = this.props;

    return (
      <div className="Row Registration-peronalizedPlateRow">
        <TextInput tabIndex="-1" className="Row-total" id="Rsub6" tooltip="Personalized Plate Fees" value={personalizedPlateFee} readOnly />

        <Dropdown
          id="PeronalizedPlateDropdown"
          tooltip="Choose the type of Personalized Plate"
          options={this.peronalizedPlateOptions()}
          onChange={this.onChange}
          selectedValue={personalizedPlateFeeSelectedValue}
          className="Dropdown Row-dropdown no-print"
        />

        <b className="print-label print-only">{personalizedPlateFeeSelectedValueLabel}</b>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    monthsFromNow: state.registration.monthsFromNow,
    selectedVehicleValue: state.registration.selectedVehicleValue,
    SVCFEE_TOTAL: state.registration.SVCFEE_TOTAL,
    secondYearFee: secondYearFeeTotal(state),
    applySecondYearFee: state.registration.applySecondYearFee,
    personalizedPlateFee: state.registration.personalizedPlateFee,
    personalizedPlateFeeSelectedValue: state.registration.personalizedPlateFeeSelectedValue,
    personalizedPlateFeeSelectedValueLabel: state.registration.personalizedPlateFeeSelectedValueLabel,
    BFfee: state.registration.BFfee,
  };
};

export default connect(mapStateToProps, { setPersonalizedPlate })(PersonalizedPlateFee);
